<template>
  <div>
    <CascadingCardSection
      v-if="card.id && card.use_cascading"
    ></CascadingCardSection>

    <card-section
      v-for="section in sections"
      :key="section.id"
      :section="section"
      :no-permission="noPermission"
      @elements-changed="$emit('elements-changed')"
    >
    </card-section>
  </div>
</template>

<script>


import CardSection from "@/components/cards/CardElementsBlock/CardSection";
import {mapGetters} from "vuex";
import CascadingCardSection from "@/modules/cascading/components/CascadingCardSection/CascadingCardSection.vue";
export default {
  name: "card-sections",
  components: { CascadingCardSection, CardSection},

  props: {
    noPermission: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters('card', {
      card: 'card',
    }),
    ...mapGetters('card/sections', {
      loading: 'loading',
      sections: 'sections'
    }),
  },
  data() {
    return {
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'card/updateCard') {
        this.$store.dispatch('card/sections/loadSections', {noPermission: this.noPermission});
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {

  }
}
</script>




<style>

</style>